<template>
    <div class="categ_list">
        <ul v-if="this.categories.length > 0" class="nav-menu nav-menu-rese nav-categ  mb-sm-4 mb-md-0 ">
        <li v-for="categ in this.categories" class="mb-2">
            <a v-on:click="set_active(categ)" href="#"
               class="p-1"
               :class="{'bg-primary' : !categ.is_active,'bg-success': categ.is_active}">
                <div class="input-group-append border-0">
                    <div class="input-group-text border-0"
                         :class="{'bg-primary' : !categ.is_active,'bg-success': categ.is_active}">
                        <div class="custom-control custom-checkbox ">
                            <input type="checkbox" v-model="categ.is_active" class="custom-control-input"
                                   :id="'cat_' + categ.id">
                            <label class="custom-control-label" :for="'cat_' + categ.id"></label>
                        </div>
                    </div>
                </div>

                <span class="ml-5 nav-link-text">
					{{ categ.title }}
				</span>

                <b class="collapse-sign pr-3 color-white" v-on:click.stop.prevent="set_active_default(categ)"
                   v-if="with_default && categ.children.length > 0 || force_super">
                    <div>
                        <i class=" fa-star fs-xxl"
                           :class="{'color-white fal' : !categ.is_selected_main,'color-warning-800 fas': categ.is_selected_main}">
                        </i>


                    </div>
                </b>

                <b class="collapse-sign pr-3" v-if="categ.children.length > 0"><em class="fal fa-angle-up"></em></b>
            </a>

            <ul class="" style="display:block;" v-if="categ.children.length > 0">
                <li class="" v-for="child in categ.children">
                    <a v-on:click="set_active(child)" href="#" class="mb-1 ml-4 p-1"
                       :class="{'bg-primary' : !child.is_active,'bg-success': child.is_active}">
                        <div class="input-group-append border-0">
                            <div class="input-group-text border-0"
                                 :class="{'bg-primary' : !child.is_active,'bg-success': child.is_active}">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" v-model="child.is_active" class="custom-control-input"
                                           :id="'cat_' + child.id">
                                    <label class="custom-control-label" :for="'cat_' + child.id">
                                    </label>
                                </div>
                            </div>
                        </div>

                        <span class="ml-5 nav-link-text">
							{{ child.title }}
						</span>

                    </a>
                </li>
            </ul>
        </li>
    </ul>
    </div>
</template>

<script>
export default {
    name: "categlist",
    props: {
        categories: {
            type: Array
        },
        with_default: {
            type: Boolean,
            default: false,
        },
        force_super : {
            type: Boolean,
            default: false,
        },
        super_ids : {
            type: Array,
            default: () => ([]),
        },
    },


    data() {
        return {
            categories_tmp: this.categories,
        }
    },

    mounted() {
        console.log('mounted');
    },


    methods: {

        check_if_super_active(categ) {
            let categ_id = parseInt(categ.id);
            if(categ.is_selected_main) {
                return true;
            }

            let is_in = false;
            if(this.super_ids.length > 0) {
                this.super_ids.map(function (id){
                    if(parseInt(id) === categ_id) {
                        is_in = true;
                    }
                })
            }

            return is_in;
        },

        set_active_default(categ) {
            if (categ.parent_id > 0) {
                let parent_categ = this.get_categ(parseInt(categ.parent_id));
                if (parent_categ != null && parent_categ.is_selected_main) {
                    this.set_active_default(parent_categ);
                }
            }

            if (parseInt(categ.parent_id) === 0) {
                if(categ.hasOwnProperty("children")) {
                    categ.children
                        .filter(item => {
                            return item.is_selected_main;
                        }).map(item => {
                            item.is_selected_main = false;
                            this.$emit('change', item);
                        });
                }
            }

            categ.is_selected_main = !categ.is_selected_main;

            if (categ.is_selected_main) {
                categ.is_active = true;
            }

            this.$emit('change_super', categ);
        },

        set_active(categ) {
            categ.is_active = !categ.is_active;
            this.$emit('change', categ);
        },

        get_categ(id) {
            let cur_categ = null;
            this.categories.map(categ => {
                if (parseInt(categ.id) === parseInt(id)) {
                    cur_categ = categ;
                }
            });

            return cur_categ;
        },

    },
    computed : {

    }


}
</script>

<style scoped>

</style>
